// removed by extract-text-webpack-plugin
module.exports = {"large":"1600px","sideNavExpanded":"184px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/Grid.css
// module id = 339
// module chunks = 0